import { formatDate } from './format';

export const getAge = (date) => {

    var _date = formatDate(date, false);

    var dob = _date.split("/").reverse().join("-");

    var year = Number(dob.substr(0, 4));
    var month = Number(dob.substr(4, 2)) - 1;
    var day = Number(dob.substr(6, 2));
    var today = new Date();
    var age = today.getFullYear() - year;

    if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        age--;
    }
    return age;
}